import styled from 'styled-components'
import {
  getFontWeight,
  type TypographyCssProps,
  typographyCss
} from '../typography'

const H1 = styled.h1<TypographyCssProps>`
  // font-weight should be overridden by headingCss
  ${typographyCss}

  font-weight: ${({ $weight = 'bold' }) => getFontWeight($weight)};

  font-size: 32px;
  line-height: 40px;
  letter-spacing: 0.0075em;
  font-feature-settings: 'ss01' on;

  ${({ theme }) => theme.mediaQueries.mobileDown} {
    font-size: 24px;
    line-height: 32px;
  }
`

const H2 = styled.h2<TypographyCssProps>`
  ${typographyCss}

  font-weight: ${({ $weight = 'medium' }) => getFontWeight($weight)};
  font-size: 28px;
  line-height: 36px;

  ${({ theme }) => theme.mediaQueries.mobileDown} {
    font-size: 22px;
    line-height: 24px;
  }
`
const H3 = styled.h3<TypographyCssProps>`
  ${typographyCss}

  font-weight: ${({ $weight = 'medium' }) => getFontWeight($weight)};
  font-size: 24px;
  line-height: 32px;

  ${({ theme }) => theme.mediaQueries.mobileDown} {
    font-size: 20px;
    line-height: 24px;
  }
`
const H4 = styled.h4<TypographyCssProps>`
  ${typographyCss}

  font-weight: ${({ $weight = 'bold' }) => getFontWeight($weight)};
  font-size: 20px;
  line-height: 24px;

  ${({ theme }) => theme.mediaQueries.mobileDown} {
    font-size: 18px;
    line-height: 20px;
  }
`
const H5 = styled.h5<TypographyCssProps>`
  ${typographyCss}

  font-weight: ${({ $weight = 'regular' }) => getFontWeight($weight)};

  font-size: 18px;
  line-height: 24px;
  ${({ theme }) => theme.mediaQueries.mobileDown} {
    font-size: 16px;
    line-height: 20px;
  }
`

export const heading = {
  1: H1,
  2: H2,
  3: H3,
  4: H4,
  5: H5
}
